import type { FC } from 'react'

import { Button } from 'common/components/Button/Button'
import { Modal } from 'common/components/Modal'

import styles from './completedBookings.module.scss'

interface UnavailableLeaseModalProps {
  bookingId: string
  isOpen: boolean
  onClose: () => void
}

export const UnavailableLeaseModal: FC<UnavailableLeaseModalProps> = ({
  bookingId,
  isOpen,
  onClose,
}) => (
  <Modal open={isOpen} onCancel={onClose} title='Booking unavailable' footer={null} destroyOnHidden>
    <div className={styles.parentUnavailableModal}>
      <p>
        Package <strong>{bookingId}</strong> ended before its contract was signed, so there are no
        booking details to show.
      </p>
      <Button onClick={onClose}>Got it</Button>
    </div>
  </Modal>
)
